import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CaregiverProfilePage from './features/CaregiverProfile/CaregiverProfilePage';
import { createTheme } from '@mui/material/styles';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5A46AA', // Care Concierge Purple
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <CaregiverProfilePage />
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default App;
